import { apiFetch, apiBlob } from "./client";

/** Everything the Expenses page shows: expenses, money in, accounts, totals. */
export function getExpenses() {
  return apiFetch("/api/admin/expenses");
}

export function getExpense(id) {
  return apiFetch(`/api/admin/expenses/${id}`);
}

export function saveExpense(id, body) {
  return id
    ? apiFetch(`/api/admin/expenses/${id}`, { method: "PUT", body })
    : apiFetch("/api/admin/expenses", { method: "POST", body });
}

export function deleteExpense(id) {
  return apiFetch(`/api/admin/expenses/${id}`, { method: "DELETE" });
}

export function saveMoneyIn(id, body) {
  return id
    ? apiFetch(`/api/admin/money-in/${id}`, { method: "PUT", body })
    : apiFetch("/api/admin/money-in", { method: "POST", body });
}

export function deleteMoneyIn(id) {
  return apiFetch(`/api/admin/money-in/${id}`, { method: "DELETE" });
}

export function saveAccount(id, body) {
  return id
    ? apiFetch(`/api/admin/expense-accounts/${id}`, { method: "PUT", body })
    : apiFetch("/api/admin/expense-accounts", { method: "POST", body });
}

/** Upload a receipt photo or statement (a File or Blob). Returns {id, filename, ...}. */
export function uploadExpenseFile(file, filename) {
  const form = new FormData();
  form.append("file", file, filename || file.name || "receipt.jpg");
  return apiFetch("/api/admin/expense-files", { method: "POST", body: form });
}

export function deleteExpenseFile(id) {
  return apiFetch(`/api/admin/expense-files/${id}`, { method: "DELETE" });
}

export function fetchExpenseFile(id) {
  return apiBlob(`/api/admin/expense-files/${id}`);
}

/** Ask the AI to read an uploaded file. Saves nothing; returns rows to review. */
export function scanExpenseFile(fileId) {
  return apiFetch("/api/admin/expenses/scan", { method: "POST", body: { file_id: fileId } });
}

export function recheckScan(accountId, rows) {
  return apiFetch("/api/admin/expenses/scan/check", { method: "POST", body: { account_id: accountId, rows } });
}

export function applyScan(body) {
  return apiFetch("/api/admin/expenses/scan/apply", { method: "POST", body });
}

export function importExpensesCsv(csv) {
  return apiFetch("/api/admin/expenses/import", { method: "POST", body: { csv } });
}

/** The spreadsheet (format "xlsx") or the receipts zip ("zip"), for a year or all time. */
export function exportExpenses(format, year) {
  const q = new URLSearchParams({ format, ...(year ? { year: String(year) } : {}) });
  return apiBlob(`/api/admin/expenses/export?${q}`);
}

/** Change one or two things on an expense: {category}, {account_id}, {spent_on}, {receipt_not_needed}, {file_ids}. */
export function patchExpense(id, patch) {
  return apiFetch(`/api/admin/expenses/${id}`, { method: "PATCH", body: patch });
}

/** The same change on many expenses: set {category|account_id|spent_on}, or delete. */
export function bulkExpenses(ids, change, del = false) {
  return apiFetch("/api/admin/expenses/bulk", { method: "POST", body: { ids, set: change || {}, delete: del } });
}

// Statements in, questions out.
export function startImport() {
  return apiFetch("/api/admin/imports", { method: "POST", body: {} });
}

export function readImportFile(batchId, fileId) {
  return apiFetch(`/api/admin/imports/${batchId}/read`, { method: "POST", body: { file_id: fileId } });
}

export function analyzeImport(batchId, files) {
  return apiFetch(`/api/admin/imports/${batchId}/analyze`, { method: "POST", body: { files } });
}

export function getReview() {
  return apiFetch("/api/admin/review");
}

export function answerItem(id, answer) {
  return apiFetch(`/api/admin/import-items/${id}/answer`, { method: "POST", body: answer });
}

export function addItems(ids) {
  return apiFetch("/api/admin/import-items/add", { method: "POST", body: { ids } });
}

export function undoItem(id) {
  return apiFetch(`/api/admin/import-items/${id}/undo`, { method: "POST", body: {} });
}
